import { patientConstants as constants } from '../_constants/patient.constants';

export const initialState = {
  isLoading: true,
  collection: [],
  current: null,
  messages: {
    collection: [],
    isLoading: false,
    hasLoaded: false,
  }
}

export function patient(state = initialState, action) {
  if (action.type === constants.PATIENT_MSGS_FAILURE) {
    return {
      ...state,
      messages: {
        ...state.messages,
        isLoading: false,
        hasLoaded: true
      }
    }
  }

  if (action.type === constants.PATIENT_MSGS_SUCCESS) {
    return {
      ...state,
      messages: {
        ...state.messages,
        hasLoaded: true,
        isLoading: false,
        collection: action.messages
      }
    }
  }

  if (action.type === constants.PATIENT_MSGS_REQUEST) {
    return {
      ...state,
      messages: {
        ...state.messages,
        isLoading: true
      }
    }
  }

  if (action.type === constants.PATIENT_RETRIEVE_CLEAR) {
    return {
      ...state,
      isLoading: false,
      current: null
    }
  }

  if (action.type === constants.PATIENT_RETRIEVE_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      current: action.patient
    }
  }

  if (action.type === constants.PATIENT_RETRIEVE_FAILURE) {
    return {
      ...state,
      isLoading: false
    }
  }

  if (action.type === constants.PATIENT_RETRIEVE_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  return state;
}